import { DragDropModule } from '@angular/cdk/drag-drop';
import { EcplImageViewerModule } from '../ecpl-image-viewer/ecpl-image-viewer.module';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { EcplChecklistViewerComponent } from './ecpl-checklist-viewer.component';
import { Router, RouterModule } from '@angular/router';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { SelectModule } from 'primeng/select';
import { DialogModule } from 'primeng/dialog';
import { WidgetsModule } from 'src/app/kuba/shared/widgets.module';

@NgModule({
  declarations: [EcplChecklistViewerComponent],
  imports: [
    CommonModule,
    DragDropModule,
    EcplImageViewerModule,
    FormsModule,
    RouterModule,
    AccordionModule,
    TranslatePipe, TranslateDirective,
    SelectModule,
    DialogModule,
    WidgetsModule
  ],
  exports: [EcplChecklistViewerComponent]
})
export class EcplChecklistViewerModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: EcplChecklistViewerModule
    };
  }
}
